export const routes = {
  // KTP
  passport: '/',
  home: '/home',
  departure: '/departure',
  departureCheck: '/departure-check',
  receiptInquiry: '/receipt',
  receipt: '/receipt-detail',
  uploadReceipt: '/receipt-upload',
  customerRefund: '/refund',
  refundResult: '/refund-result',
  refundProcedure: '/refund-procedure',
  refundInfo: '/refund-info',
  refundInfoLeaflet: '/refund-info-leaflet',
  locationPrint: '/location-print',
  locationPrintCruise: '/location-print-cruise',
  locationCustoms: '/location-customs',
  locationCustomsCruise: '/location-customs-cruise',
  myPage: '/mypage',
  faq: '/faq',
  faqEmail: '/faq-email',
  airport: '/airport',
  selectAirport: '/select-airport',
  airportNonRefundable: '/airport-non-refundable',
  airportGuide: '/airport-guide',
  airportLocation: '/airport-location',
  airportReceipt: '/airport-receipt',
  airportPrintReceipt: '/airport-print-receipt',
  airportFaq: '/airport-faq',
  inquiryFaq: '/inquiry/faq',
  inquiryPassport: '/inquiry/passport',
  inquiryEmail: '/inquiry/email',
  inquiryQna: '/inquiry/qna',
  cashPickupIntro: '/cash-pickup-intro',
};
